import { render, staticRenderFns } from "./ContainerWidget.vue?vue&type=template&id=260186e3&scoped=true"
import script from "./ContainerWidget.vue?vue&type=script&lang=js"
export * from "./ContainerWidget.vue?vue&type=script&lang=js"
import style0 from "./ContainerWidget.vue?vue&type=style&index=0&id=260186e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260186e3",
  null
  
)

export default component.exports